// Was eine Karte ZEIGT -- pro Nutzer, pro Karte, neben dem Layout.
//
// Getrennt von card-layout.ts mit Absicht: dort steht, WO eine Karte
// liegt und wie gross sie ist, hier steht, WAS auf ihr steht. Beides
// aendert man an verschiedenen Stellen (Ziehen vs. Zahnrad), und ein
// Reset des Rasters soll die Auswahl der Werte nicht mitnehmen.
//
// Leere Konfiguration = die Vorgabe der Seite. Erst eine bewusste
// Auswahl wird gespeichert; so bekommt eine neue Karte automatisch die
// sinnvolle Standard-Darstellung, statt leer zu bleiben.

import { getPref, setPref } from "./prefs.svelte";

/** Darstellung einer Karte. */
export type Kartenmodus = "wert" | "liste" | "verlauf";

export interface CardConfig {
  modus: Kartenmodus;
  /** Slug des Leitwerts (die grosse Zahl). Leer = Vorgabe der Seite. */
  leit?: string;
  /** Slugs der zusaetzlich gelisteten Werte. undefined = alle.
   *  Bei den festen Karten (Energie, Wetter, Klima, Netzfrequenz) sind
   *  das die Bausteine der Karte bzw. die Sensoren, nicht Geraete-Werte. */
  felder?: string[];
  /** Zeitfenster des Verlaufs in Stunden (Brueche erlaubt: 0.25 = 15 min). */
  stunden?: number;
  /** Anzahl gezeigter Zeilen, wo die Karte eine Liste fuehrt. */
  anzahl?: number;
}

/** Zahlen-Auswahl im Karten-Dialog (Zeitfenster, Zeilenzahl). Welches
 *  Feld sie setzt, sagt die Karte -- so bekommt jede nur die Abschnitte,
 *  die bei ihr wirklich etwas bewirken. */
export interface ZahlAbschnitt {
  feld: "stunden" | "anzahl";
  titel: string;
  vorgabe: number;
  optionen: { wert: number; label: string }[];
}

const KEY_PREFIX = "card_config_";

function key(group: string): string {
  return `${KEY_PREFIX}${group}`;
}

function alle(group: string): Record<string, CardConfig> {
  return getPref<Record<string, CardConfig>>(key(group)) ?? {};
}

/** Reaktiv (liest den prefs-Store). fallback gilt, solange nichts gewaehlt wurde. */
export function getCardConfig(group: string, id: string, fallback: CardConfig): CardConfig {
  const c = alle(group)[id];
  if (!c) return fallback;
  return { ...fallback, ...c };
}

export function setCardConfig(group: string, id: string, cfg: CardConfig): void {
  setPref(key(group), { ...alle(group), [id]: cfg });
}

/** Zuruecksetzen auf die Vorgabe der Seite (Eintrag faellt ganz weg). */
export function resetCardConfig(group: string, id: string): void {
  const next = { ...alle(group) };
  delete next[id];
  setPref(key(group), next);
}
